export default {
    path: '/admin/login',
    component: () => import('@/pages/admin/login/index.vue'),

};
